import { render } from "./image-uploader.vue?vue&type=template&id=1a031490&scoped=true&lang=pug"
import script from "./image-uploader.vue?vue&type=script&lang=js"
export * from "./image-uploader.vue?vue&type=script&lang=js"

import "./image-uploader.vue?vue&type=style&index=0&id=1a031490&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a031490"]])

export default __exports__